import {
	axiosErrorHandler,
	get,
	post,
	put,
} from 'models/shared/helpers/axiosInstance';
import {
	CreateSkuVariantDto,
	SkuVariant,
	UpdateSkuVariantDto,
} from '../interfaces/sku-variant.interface';

const basePath = (skuId: string) => `/v1/skus/${skuId}/variants`;

export const createSkuVariant = async (
	skuId: string,
	dto: CreateSkuVariantDto,
) => {
	try {
		const res = await post<SkuVariant>(basePath(skuId), dto);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const getSkuVariantsBySku = async (skuId: string) => {
	try {
		const res = await get<SkuVariant[]>(basePath(skuId));
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const updateSkuVariant = async (
	skuId: string,
	id: string,
	dto: UpdateSkuVariantDto,
) => {
	try {
		const res = await put<SkuVariant>(`${basePath(skuId)}/${id}`, dto);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
